import { css } from '@emotion/css'
import React from 'react'

const InputWrapperStyle = css`
  position: relative;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  color: #0e0c28;
  border: none;
  height: 50px;
  background-color: #f6f6f6;

  &.invalid {
    background-color: rgba(255, 0, 0, 10%);
    label {
      color: inherit !important;
    }
  }

  label {
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
    transition: transform 0.3s ease;

    span {
      color: red;
      font-weight: 500;
    }
  }

  input {
    height: auto;
    border: none !important;
    background-color: transparent;
    margin-top: 12px;
  }

  .active,
  input:focus + label {
    transform: translateY(-20px);
    color: #699bf7;
  }
`

interface IInputCampaign
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string
  type?: 'text' | 'number' | 'date' | 'datetime-local'
  label: string
  required?: boolean
  errors?: any
  touched?: any
  isActive?: boolean
}

function InputCampaign(props: IInputCampaign) {
  const {
    id,
    type = 'text',
    label,
    required,
    errors,
    touched,
    isActive,
    onChange,
    name,
    value,
    ...otherProps
  } = props

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let next = e.currentTarget.value

    // Sadece date ve datetime-local için kontrol yapılır
    if (type === 'date' || type === 'datetime-local') {
      if (/^\d{5}-/.test(next)) {
        // Fazla haneli yıl hatasını düzelt
        next = next.slice(0, 4) + next.slice(5)
      }
    }

    if (next !== e.currentTarget.value) {
      e.currentTarget.value = next
    }

    onChange?.(e)
  }

  return (
    <div className={`${InputWrapperStyle} ${errors && touched ? 'invalid' : ''}`}>
      <input
        id={id}
        name={name ?? id}
        type={type}
        value={value}
        onChange={handleInputChange}
        inputMode={type === 'number' ? 'numeric' : undefined}
        {...otherProps}
      />
      <label
        className={(value && value.toString().length > 0) || isActive ? 'active' : ''}
        htmlFor={id}
      >
        {label}
        {required && <span> * {errors && touched && errors}</span>}
      </label>
    </div>
  )
}

export default InputCampaign
